import { Component, ErrorHandler, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { LaskuToimittaja } from '@lemon/core-firebase/model/lasku'
import { FirestoreTosite } from '@lemon/core-firebase/model/tosite'
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { firstValueFrom, map, Observable, Subject, switchMap, takeUntil } from 'rxjs'
import { LaskuService } from '../_angular/service/lasku/lasku.service'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'

export interface MaksutToimittajaPoistoVarmistusDialogData {
  toimittaja: LaskuToimittaja
  odotaReplikointiTyojononKasittelyObservable: Observable<any>
}

@Component({
  selector: 'MaksutToimittajaPoistoVarmistusDialog',
  templateUrl: './maksut-toimittaja-poisto-varmistus.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaksutToimittajaPoistoVarmistusDialog implements OnInit, OnDestroy {
  toimittajaOnKaytossaObservable: Observable<boolean>

  private _ngUnsubscribe = new Subject<void>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MaksutToimittajaPoistoVarmistusDialogData,
    private errorHandler: ErrorHandler,
    private dialogRef: MatDialogRef<MaksutToimittajaPoistoVarmistusDialog>,
    private ladataanService: LadataanService,
    private laskuService: LaskuService,
    private kayttajaService: KayttajaService,
    private tositeUriService: TositeUriService,
    private firebaseLemonaid: FirebaseLemonaid,
  ) {}

  ngOnInit() {
    this.toimittajaOnKaytossaObservable = this.kayttajaService.nykyinenAsiakasObservable.pipe(
      takeUntil(this._ngUnsubscribe),
      switchMap(asiakas => {
        const uri = this.tositeUriService.annaTositteidenFirestoreCollectionUri(asiakas.asiakasAvain)
        return this.firebaseLemonaid.firestoreCollection<FirestoreTosite>(uri).where('toimittajaAvain', '==', this.data.toimittaja.avain).limit(1).listen()
      }),
      map(tosite => {
        return !!tosite.length
      }),
    )
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  async poista() {
    this.ladataanService.aloitaLataaminen()
    try {
      await this.laskuService.poistaToimittajat([this.data.toimittaja])
      await firstValueFrom(this.data.odotaReplikointiTyojononKasittelyObservable)
      this.ladataanService.lopetaLataaminen()
      this.dialogRef.close(true)
    } catch (err) {
      this.ladataanService.lopetaLataaminen()
      this.errorHandler.handleError(err)
      this.dialogRef.close(true)
    }
  }
}
